import { render, staticRenderFns } from "./NavType.vue?vue&type=template&id=63fa64aa"
import script from "./NavType.vue?vue&type=script&lang=js"
export * from "./NavType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports